import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [access, setAccess] = useState(null);

  const loadAccess = useCallback(async () => {
    try {
      const { data } = await api.get("/me/access");
      setAccess(data);
    } catch {
      setAccess(null);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        await loadAccess();
      } catch {
        setUser(false);
      }
    })();
  }, [loadAccess]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    await loadAccess();
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    await loadAccess();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
    setAccess(null);
  };

  return (
    <AuthContext.Provider value={{ user, access, login, register, logout, loadAccess, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
